<div class="mr-stepper" [attr.data-variant]="block.variant || 'brand'">
  <p class="mr-stepper-caption" *ngIf="block.caption">{{ t(block.caption) }}</p>
  <div class="mr-stepper-dots">
    <span
      class="mr-dot"
      *ngFor="let i of range(block.total)"
      [class.filled]="i < block.current"
      [class.active]="i === block.current - 1"
    ></span>
  </div>
</div>
